import { useState } from "react";
import type { WizardData } from "./HierarchyManagement";

export const useWizardState = () => {
  const [wizardStep, setWizardStep] = useState(0);
  const [wizardData, setWizardData] = useState<WizardData>({});
  const [nurseryMode, setNurseryMode] = useState<"attach" | "create">("attach");
  const [override, setOverride] = useState<Record<string, boolean>>({});
  const [initialOverride, setInitialOverride] = useState<Record<string, boolean>>({});
  const [nurseryOverride, setNurseryOverride] = useState<Record<string, boolean>>({});
  const [initialNurseryOverride, setInitialNurseryOverride] = useState<Record<string, boolean>>({});

  const resetWizard = () => {
    setWizardStep(0);
    setWizardData({});
    setOverride({});
    setInitialOverride({});
    setNurseryOverride({});
    setInitialNurseryOverride({});
  };

  return {
    wizardStep,
    setWizardStep,
    wizardData,
    setWizardData,
    nurseryMode,
    setNurseryMode,
    override,
    setOverride,
    initialOverride,
    setInitialOverride,
    nurseryOverride,
    setNurseryOverride,
    initialNurseryOverride,
    setInitialNurseryOverride,
    resetWizard,
  };
};